<template>
    <b-container fluid>
        <b-row>
            <div class="images grid" v-if="this.images.length" v-viewer="options">
                <div class="image-item" v-for="(img, index) in images" :key="index">
                    <font-awesome-icon
                            class="zoom-icon"
                            :icon="['fas', 'search']"
                            size="2x"
                    >
                    </font-awesome-icon>
                    <img :src="img.thumbnail" :data-source="img.url" :alt="img.originalFileName">
                    <div class="img-legend">
                        <p>{{ img.originalFileName }}</p>
                    </div>
                </div>
            </div>
        </b-row>
    </b-container>
</template>

<script>
export default {
  name: 'Image-Grid',
  data() {
    return {
      modalId: 'image-grid',
      modalLabel: 'Image Grid',
      size: 'full-screen', // full-screen is also an option
    };
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
    .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 5px;
        align-items: start;
        justify-items: start;

        .image-item {
            position: relative;
            max-height: 180px;
            width: 100%;
            overflow: hidden;
            cursor: pointer;

            .zoom-icon {
                pointer-events: none;
                display: none;
                color: $white;
            }

            img {
                border: 1px solid #ccc;
                -webkit-box-shadow: 2px 2px 6px 0 rgba(0,0,0,.3);
                box-shadow: 2px 2px 6px 0 rgba(0,0,0,.3);
                width: 100%;
                height: 180px;
                -o-object-fit: cover;
                object-fit: cover;
            }

            .img-legend {
                position: absolute;
                display: inline-block;
                bottom: 0;
                width: 100%;
                height: 25px;
                max-height: 25px;
                left: 0px;

                p {
                    text-align: center;
                    background: #0000009e;
                    color: #fff;
                    font-weight: bold;
                    margin: 0 1px;
                    height: inherit;
                    max-height: inherit;
                    line-height: 25px;
                    font-size: 13px;
                }
            }

            &:hover {
                .zoom-icon {
                    display: block;
                    position: absolute;
                    z-index: 1;
                    top: 50%;
                    left: 50%;
                    margin-left: -15px;
                    margin-top: -15px;
                }

                img {
                    -webkit-filter: brightness(60%);
                    filter: brightness(60%);
                    -webkit-transition: all .2s ease;
                    -moz-transition: all .2s ease;
                    -o-transition: all .2s ease;
                    -ms-transition: all .2s ease;
                    transition: all .2s ease;
                }
            }
        }
    }

    @include media-breakpoint-up(sm) {
        .grid {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }

    @include media-breakpoint-up(md) {
        .grid {
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }
    }

    @include media-breakpoint-up(lg) {
        .grid {
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        }
    }

    @include media-breakpoint-up(xl) {
        .grid {
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        }
    }
</style>
